(function (root) {
    'use strict';
    function createParser(onEvent) {
        var buffer = '', eventName = '', data = [];
        function line(value) {
            if (!value) {
                if (data.length) { onEvent(eventName || 'message', data.join('\n')); }
                eventName = ''; data = []; return;
            }
            if (value.charAt(0) === ':') { return; }
            var colon = value.indexOf(':'), field = colon < 0 ? value : value.slice(0, colon);
            var content = colon < 0 ? '' : value.slice(colon + 1).replace(/^ /, '');
            if (field === 'event') { eventName = content; }
            if (field === 'data') { data.push(content); }
        }
        return {push: function (chunk) {
            buffer += chunk;
            if (buffer.length > 262144) { throw new Error('Événement trop volumineux'); }
            var end;
            while ((end = buffer.indexOf('\n')) >= 0) {
                line(buffer.slice(0, end).replace(/\r$/, '')); buffer = buffer.slice(end + 1);
            }
        }};
    }
    function positiveId(value) { return /^[1-9][0-9]*$/.test(String(value || '')); }
    function selectionFingerprint(query, collectorOnly) {
        return JSON.stringify([String(query || '').trim(), collectorOnly === null ? null : collectorOnly]);
    }
    var api = {createParser: createParser, positiveId: positiveId, selectionFingerprint: selectionFingerprint};
    if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
    if (root.angular) { root.angular.module('wamasysApp').factory('NotificationProtocol', function () { return api; }); }
}(typeof window === 'undefined' ? this : window));
